import { useYellowhiveFlowsConfigureStore } from '@flows/src/store/zustand/flows-configure/yellowhiveFlowsConfigureStore';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import ContentWrapper from '@flows/src/components/flows-configure/shared/ContentWrapper';
import FlowsConfigureInsuranceItems from '@flows/src/components/flows-configure/insurances/FlowsConfigureInsuranceItems';
import { FLOWS_CONFIG_PATH } from '@flows/src/FlowsConfigRouter';
import { useFlowsConfigureParams } from '@flows/src/hooks/flows-configure/useFlowsConfigureParams';
import LoadingSpinner from '@common/src/components/LoadingSpinner';
import useQueryParams from '@common/src/hooks/useQueryParams';
import { PartyType } from '../../../../../types/SMT';
import { useYellowhiveFlowsInsurances } from '@flows/src/api/yellowhive-flows/getYellowhiveFlowsInsurances';

const FlowsConfigureInsurancesYellowHive: FC = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { flowId } = useFlowsConfigureParams();
  const queryparams = useQueryParams();
  const partyType = (queryparams.get('type') as PartyType) || 'CUSTOMER';

  const { data: yellowhiveInsurances, isLoading } =
    useYellowhiveFlowsInsurances(partyType);
  const [error, setError] = useState<string | undefined>(undefined);

  const handleNext = () => {
    const firstInsurance =
      useYellowhiveFlowsConfigureStore.getState().insurances[0];
    if (!firstInsurance) {
      setError(t('Please select an insurance'));
      return;
    }
    if (error) setError(undefined);

    history.push({
      pathname: `${FLOWS_CONFIG_PATH}/${flowId}/insurances/${firstInsurance.code}/coverages`,
      search: window.location.search,
    });
  };

  return (
    <ContentWrapper
      onNext={handleNext}
      question={t('What kind of insurance are you looking for?')}
      error={error}
    >
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <FlowsConfigureInsuranceItems
          clearError={() => setError(undefined)}
          isError={!!error}
          items={yellowhiveInsurances?.items || []}
        />
      )}
    </ContentWrapper>
  );
};

export default FlowsConfigureInsurancesYellowHive;
